<template>
  <div class="main-form ic-form header-form itinerary-form dark-form" :class="mainFormContainer">
    <form  role="form" class="jsStationAlerts" name="searchTrain" method="post" :action="action" autocomplete="off" id="searchTrainForm">
      <slot name="extra"></slot>
      <div class="row gx-lg-5 py-3">
        <div class="col-12 justify-content-between d-flex">
          <h3 class="mb-3">
            {{$t('ic_new_gdzie_dzis_jedziemy')}}
          </h3>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" @click.prevent="hideAdvView"
                  v-show="(isAdvancedViewActive && !forceAdvView) && !isSimpleViewActive "></button>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" @click.prevent="hideSimpleView"
                  v-show="(isMobile && isSimpleViewActive)"></button>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" @click.prevent="hideSimpleViewDesktop"
                  v-show="(!isMobile && isSimpleViewActive)"></button>
        </div>
        <div class="" :class="destinations">
         <div class="typehead-container mb-3">
          <slot name="destination-from">
            <div role="combobox" aria-haspopup="listbox"  aria-expanded="false" class="start no-border">
                <div class="input-group"> 
                    <input type="search" id="stname-0" name="stname[0]" :value="stname0" class="jsStationTypeaheadItem jsNearestStationItem form-control"  placeholder="np. Warszawa Centralna" autocomplete="off"  role="searchbox" aria-multiline="false" aria-autocomplete="list" />
                    <input type="hidden" name="stid[0]" id="stid-0" :value="stid0" class="jsTypeaheadItem-Value" />
                    <div class="input-group-append">
                          SKĄD
                    </div>
                </div> 
               
            </div>
          </slot>
            <a @click.prevent=reverse class="switch d-flex h-100 align-items-center focus"  tabindex="0">
              <i class="bi bi-arrow-down-up"></i><span class="sr-only">Zamień stację odjazdu ze stacją przyjazdu.</span>
            </a>
          </div>
          <div class="typehead-container mb-3" v-show="isAdvancedViewActive">
            <slot name="destination-via">
            <div role="combobox" aria-haspopup="listbox"  aria-expanded="false" class="multiple-dest no-border">
              <div class="input-group"> 
                  <input type="search" id="vianame-1" name="vianame[1]" value="" class="jsStationTypeaheadItem jsNearestStationItem form-control"  placeholder="np. Poznań Gł." autocomplete="off"  role="searchbox" aria-multiline="false" aria-autocomplete="list" />
                  <input type="hidden" name="vianame[0]" value="" class="jsTypeaheadItem-Value" />
                  <div class="input-group-append">
                        PRZEZ
                  </div>
              </div> 
            </div>
          </slot>
          </div>
          <div class="typehead-container mb-3">
            <slot name="destination-to">
            <div role="combobox" aria-haspopup="listbox"  aria-expanded="false" class="end no-border">
              <div class="input-group"> 
                  <input type="search" id="stname-1" name="stname[1]" :value="stname1" class="jsStationTypeaheadItem jsNearestStationItem form-control"  placeholder="np. Szczecin Gł." autocomplete="off"  role="searchbox" aria-multiline="false" aria-autocomplete="list" />
                  <input type="hidden" name="stid[1]" id="stid-1" :value="stid1" class="jsTypeaheadItem-Value" />
                  <div class="input-group-append">
                        DOKĄD
                  </div>
              </div> 
            </div>
          </slot>
          </div>
        </div>
        <div class="" :class="timeDetails">
          <div class="mb-3" v-show="isAdvancedViewActive">
            <slot name="time-details-slot">
            <fieldset>
              <legend class="sr-only">Lorem ipsum</legend>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="arr" id="inlineRadio1"
                       value="1" ref="extra1" >
                <label class="form-check-label" for="inlineRadio1">Przyjazd</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="arr" id="inlineRadio2"
                       value="0" checked>
                <label class="form-check-label" for="inlineRadio2">Odjazd</label>
              </div>
            </fieldset>
            </slot>
          </div>
          <div class="mb-3">
            <slot name="date-time-pickers">
              <date-time></date-time>
            </slot>
          </div>
          <div class="mb-3" v-show="isAdvancedViewActive">
            <slot name='rodzaj-pociagu'>
            <fieldset>
              <legend class="sr-only">Rodzaj pociągu</legend>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" name="category[]" id="inlineCheckbox1" value="eip" checked>
                <label class="form-check-label" for="inlineCheckbox1">EIP</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" name="category[]" id="inlineCheckbox2" value="eic" checked>
                <label class="form-check-label" for="inlineCheckbox2">EIC</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" name="category[]" id="inlineCheckbox3" value="icp" checked>
                <label class="form-check-label" for="inlineCheckbox3">IC</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" name="category[]" id="inlineCheckbox4" value="tlk" checked>
                <label class="form-check-label" for="inlineCheckbox4">TLK</label>
              </div>
            </fieldset>
            </slot>
          </div>
        </div>
        <div class="col-12 col-lg-4" v-show="isAdvancedViewActive">
          <slot name="dodatkowe">
          <fieldset>
                        <legend class="sr-only">Wybierz dodatkowe opcje połączenia</legend>
                        <div class="form-check mb-3 mtn">
                            <input type="checkbox" class="form-check-input" value="1" name="direct" id="ic-seek-direct">
                            <label for="ic-seek-direct" class="form-check-label">
                                tylko połączenie bezpośrednie
                            </label>
                        </div>
                          <div class="form-check mb-3 mtn">
                            <input type="checkbox" class="form-check-input" value="1" name="bike" id="ic-seek-bike">
                            <label for="ic-seek-bike" class="form-check-label">                                
                                 możliwość przewozu rowerów
                            </label>
                        </div>
                          <div class="form-check mb-3">
                            <input type="checkbox" class="form-check-input" value="1" name="couchette" id="ic-seek-couchette">
                            <label for="ic-seek-couchette" class="form-check-label">                                
                                 z miejscami do leżenia
                            </label>
                        </div>
                          <div class="form-check mb-3">
                            <input type="checkbox" class="form-check-input" value="1" name="sleeper" id="ic-seek-sleeper">
                            <label for="ic-seek-sleeper" class="form-check-label">                                
                                 z wagonami sypialnymi
                            </label>
                        </div>
                          <div class="form-check mb-3">
                            <input type="checkbox" class="form-check-input" value="1" name="disabled" id="ic-seek-for_disabled">
                            <label for="ic-seek-for_disabled" class="form-check-label">                                
                                 wagon z platformą/windą dla osób poruszających się na wózkach
                            </label>
                        </div>
                          <div class="form-check mb-3">
                            <input type="checkbox" class="form-check-input" value="1" name="braille" id="ic-seek-braille">
                            <label for="ic-seek-braille" class="form-check-label">                                
                                 wagon z oznaczeniami w alfabecie Braille'a
                            </label>
                        </div>
                    </fieldset>
        </slot>

        </div>
      </div>
      <div class="row gy-5 pb-3">
        <div class="col-12">
          <div class="mb-3">
            <div class="alerts">
              <slot name="alerts-slot">
                <div class="alert alert-warning font-size-sm" role="alert">
                  W pociągach PKP Intercity jednocześnie zajętych może być co najwyżej 50 proc. miejsc siedzących.<br>
                  <a href="#">Więcej informacji na temat obowiązujących zasad w podróży</a>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
      <div class="row  gy-5 gx-lg-5">
        <div class="col-12 col-md-4 justify-content-md-start history" v-show="0 && isAdvancedViewActive">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-info btn-sm" aria-label="Lorem ipsum">Poznań główny - Gdańsk główny</button>
            <button type="button" class="btn btn-info btn-sm" aria-label="Lorem ipsum"><i class="bi bi-x-circle"></i></button>
          </div>
        </div>
        <div class="" :class="searchBtn">
    
                    <input type="hidden" name="hafasPage" value="{$hafas_page}" class="jsVariable-HafasPage" />
                    <input type="hidden" name="hafasSort" value="" class="jsVariable-HafasSort" />
                    <input type="hidden" name="search" value="1" class="jsVariable-HafasSort" />
                    <div id='recaptcha' class="g-recaptcha"  data-tabindex="99" data-sitekey="6LfNgbIZAAAAAJRnN7xCoQZH-gq-fiMYFAoNxOcR" data-callback='onSubmitSearchForm' data-action='submit' data-size="invisible"></div>

          <button type="submit" name="search" value="1" class="btn btn-warning mb-2 w-100"  onClick="return grecaptcha.execute();">{{$t('icsearch_wyszukaj')}}</button>
        </div>
      </div>
      <p v-if="!forceAdvView">
        <a href="#" @click.prevent="toggleAdvView" class="btn-link btn-adv-search focus" :aria-expanded="isAdvancedViewActive.toString()" ref="advToggle">
          <template v-if="!isAdvancedViewActive">{{$t('icsearch_wyszukiwarka_szczegolowa')}}</template>
          <template v-if="isAdvancedViewActive">{{$t('icsearch_wyszukiwarka_standard')}}</template>
        </a>
      </p>
      <div>
        <slot name="dev"></slot>
      </div>
    </form>      
  </div>

</template>
<script>
//import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import DateTime from './inputs/date-time';
import 'vue2-datepicker/index.css';
import {debounce} from 'lodash';
import Vue from "vue";

export default {
  name: 'itinerary-ozn-form',
  props: {
    action: '/pl/site/dla-pasazera/informacje/wyszukiwarka-polaczen.html',
    forceAdvView: false,
    wymus: String,
    localization: {
      type: String,
      default: 'top'
    },
    stid0: String,
    stid1: String,
    stname0: String,
    stname1: String,
  },
  components: {
    //VueTypeaheadBootstrap,
    DateTime
  },
  data() {
    return {
      query1: '',
      users: [],

      query2: '',
      query3: '',
      time: null,
      isQuery2AdditionalInfoAvailable: false,
      query2AdditionalInfo: ' ',
      query2Class: 'plus',
      isAdvancedViewActive: false,
      isMobile: false,
      isSimpleViewActive: false,
    }
  },
  computed: {
    searchBtn: function () {
      let cl = 'col-12 justify-content-center';
      if (this.isAdvancedViewActive)
        cl = 'col-12 col-md-4 offset-md-4 justify-content-md-end  justify-content-center';
      return cl;
    },
    mainFormContainer: function () {
      let cl;

      let fixedMobile = 'position-fixed h-100 top-0 start-0 header-form__adv overflow-auto zindex-fixed';

      if(window.kategoria_podstrona)
        var absoluteDesktop = 'top-0 start-0 header-form__adv';
      else if(window.podstrona)
        var absoluteDesktop = 'position-fixed top-50 start-50 translate-middle header-form__adv';
      else
        var absoluteDesktop = 'position-absolute top-0 start-0 header-form__adv';

      if (this.localization === 'top') {
        cl = 'my-5 header-form__simple';

        if (this.isAdvancedViewActive) {
          if(this.forceAdvView)
            cl = 'header-form__adv';
          else {
            if(this.isMobile) {
              cl = fixedMobile;
            }
            else {
              cl = absoluteDesktop;
            }
          }
        }
      }
      if (this.localization === 'sidebar') {
        if (this.isMobile)
          if (this.isSimpleViewActive)
            cl = fixedMobile;
          else
            cl = 'd-none';

        if (this.isAdvancedViewActive) {
          if (this.isMobile)
            cl = fixedMobile;
          else
            cl = absoluteDesktop;
        }
      }

      return cl;
    },
    destinations: function () {
      let cl = 'col-12 ';
      if (this.isAdvancedViewActive)
        cl = 'col-12 col-lg-4';
      return cl;
    },
    timeDetails: function () {
      let cl = 'col-12';
      if (this.isAdvancedViewActive)
        cl = 'col-12 col-lg-4';
      return cl;
    }
  },
  methods: {
    reverse() {
      var n0 = $("#stname-0").val();
      var n1 = $("#stname-1").val();
      var i0 = $("#stid-0").val();
      var i1 = $("#stid-1").val();
      $("#stname-0").val(n1);
      $("#stname-1").val(n0);
      $("#stid-0").val(i1);
      $("#stid-1").val(i0);

      //console.log("reverse");
      
    },
    showSimpleView() {
      this.isSimpleViewActive = true;
    },
    showSimpleViewDesktop() {
      $("#floatingSearch").removeClass('d-lg-none').addClass("position-fixed top-50 start-50 translate-middle");
      $("#floatingSearchB").removeClass('d-none');
     this.focusInput();
      this.isSimpleViewActive = true;
    },
    hideSimpleViewDesktop(){
      $("#floatingSearch").addClass('d-lg-none').removeClass("position-fixed top-50 start-50 translate-middle");
      $("#floatingSearchB").addClass('d-none');
      this.isSimpleViewActive = false;
      if(this.isAdvancedViewActive)
        this.hideAdvView();      
    },
    hideSimpleView() {
      this.isSimpleViewActive = false;
      if(this.isAdvancedViewActive)
        this.hideAdvView();
    },
    showAdvView() {
      this.isAdvancedViewActive = true;
      this.focusInput();
    },
    hideAdvView() {
      this.isAdvancedViewActive = false;
      if(!window.kategoria_podstrona)
        $("#floatingSearchB").addClass('d-none');
    },
    toggleAdvView() {
      if(this.isAdvancedViewActive) {
        $("#floatingSearch").removeClass("advanced");
        if(!window.kategoria_podstrona)
          $("#floatingSearchB").addClass('d-none');
        this.isAdvancedViewActive = false;
      }
      else {
        $("#floatingSearch").addClass("advanced");
        $("#floatingSearchB").removeClass('d-none');
        this.isAdvancedViewActive = true;
        this.focusInput();
      }
    },
    focusInput() {
      $("#stname-0").focus();
    },
    searchUsers: debounce(function () {
      if (this.query1.length > 0) {
        fetch(`https://api.github.com/search/users?q=${this.query1}`)
            .then(response => {
              return response.json();
            })
            .then(data => {
              this.users = data.items;
            })
      }
    }, 150),
    showTicketSearch: function () {
      if(window.kategoria_podstrona && !this.isMobile)
        this.showSimpleViewDesktop();
      else
        this.showSimpleView();
      //$("#floatingSearch").removeClass("d-lg-none");
      ////console.log('form-mod: showTicketSearch');
    },
    handleResize() {
      this.$nextTick(() => {
        this.isMobile = window.innerWidth < 992;
      })
    },
  },
  watch: {
    forceAdvView: {
      handler: function () {
        if (this.forceAdvView)
          this.showAdvView();
      },
      immediate: true
    }
  },
  created: function () {
    this.$bus.$on('show-ticket-search', this.showTicketSearch);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    if(this.wymus) this.forceAdvView = true;
      setTimeout(function(){
        var e = $('#ic-search-results');
        //console.log(e,'test');
        if (e.length > 0) {
            
            $('body,html').animate({
                'scrollTop' : e.offset().top - 50
            }, 200);
        }

      },500)

  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}


</script>
